import axios from "axios";
import router from "../router/index";
import store from "../store/index";

import { TOKEN_STRING, TokenService } from "./storage.service";
import {
  interceptorRequest,
  interceptorRequestError,
} from "./interceptors/request";
import { interceptorResponse } from "./interceptors/response";

const headers = {
  // 'Access-Control-Allow-Origin': '*',
  "api-version": null,
};

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: headers,
});

let resInterceptor;

const createAxiosResponseInterceptor = () => {
  httpClient.interceptors.response.handlers = [];
  resInterceptor = httpClient.interceptors.response.use(
    interceptorResponse,
    interceptorResponseError
  );
};

function onRefreshFailed(error) {
  console.log("http-response-error", error);

  //clear token, vuex account
  TokenService.removeToken();
  TokenService.removeRefreshToken();
  store.commit("account/logoutSuccess");

  router.push({ name: "Login" });

  return Promise.reject(error);
}

async function onRefreshSuccess(response, config) {
  if (response?.data && response.status === 200) {
    const accessToken = response.data.access_token;
    const refreshToken = response.data.refresh_token;

    if (accessToken && refreshToken) {
      TokenService.saveToken(accessToken);
      TokenService.saveRefreshToken(refreshToken);

      store.commit("account/loginSuccess", {
        accessToken: accessToken,
        refreshToken: refreshToken,
      });

      console.log("store.commit");
      config.headers["Authorization"] = TOKEN_STRING + " " + accessToken;
    }
  }

  const _axios = await axios.request(config);

  return {
    data: _axios.data.data,
    resStatusCode: _axios.status,
    resStatusText: _axios.statusText,
    resData: _axios.data,
  };
}

function tryRefreshToken(config) {
  const stateRefreshToken =
    store.state.account?.user
      ? store.state.account.user.refreshToken
      : null;
  const storageRefreshToken = TokenService.getRefreshToken();
  const formData = new FormData();
  formData.append("grant_type", "refresh_token");
  formData.append("refresh_token", stateRefreshToken || storageRefreshToken);

  return axios
    .post(process.env.VUE_APP_HOST_API + "oauth/access_token", formData)
    .then(async (response) => onRefreshSuccess(response, config))
    .catch(onRefreshFailed)
    .finally(createAxiosResponseInterceptor);
}

const interceptorResponseError = async (error) => {
  console.log("resInterceptor:ERROR", error);

  if (error.response === undefined) {
    console.log("error.response", error.response);
    throw error;
  }

  // Reject promise if usual error
  if (error.response && error.response.status !== 401) {
    console.log("error.response.status", error.response.status);

    throw error;
  }

  /*
   * When response code is 401, try to refresh the token.
   * Eject the interceptor so it doesn't loop in case
   * token refresh causes the 401 response
   */
  httpClient.interceptors.response.eject(resInterceptor);

  return tryRefreshToken(error.response.config);
};

httpClient.interceptors.request.use(
  interceptorRequest,
  interceptorRequestError
);

resInterceptor = httpClient.interceptors.response.use(
  interceptorResponse,
  interceptorResponseError
);

export default httpClient;
